import { render, staticRenderFns } from "./CategoryLegend.vue?vue&type=template&id=103fb598&"
import script from "./CategoryLegend.vue?vue&type=script&lang=js&"
export * from "./CategoryLegend.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports